import { useMutation } from "@tanstack/react-query";
import { lgnPwdResetApi, pwdRestApi } from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  alertControl,
  emailRegex,
  englishRegex,
  modalControl,
  numberRegex,
  specialCharRegex,
  successControl,
} from "util/commAction";

export default function ResetPwdView() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const { userInf } = useAuthContext();

  const [lgnPwd, setLgnPwd] = useState("");
  const [emlId, setemlId] = useState("");

  const [valid, setValid] = useState({
    isEnCharValid: false,
    isNumCharValid: false,
    isSpecialCharValid: false,
    isRangeCharValid: false,
    isEquali: false,
  });

  const lgnPwdResetMutation = useMutation({
    mutationFn: lgnPwdResetApi, //로그인 상태에서의 비밀번호 재설정
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.stauts,
          success: () => {
            alertControl({
              isOpen: true,
              inner: t("txt_pwd_sett_mpg"),
            });
          },
        });
      }
    },
  });

  // 비밀번호 재 설정
  const handleResetPwd = () => {
    alertControl({
      isOpen: true,
      inner: t("alr_rst_pwd"),
      cncl_btn: true,
      click: () => {
        lgnPwdResetMutation.mutate({
          emlId: userInf?.emlId || emlId,
          lgnPwd: lgnPwd,
          param: search,
        });
      },
    });
  };

  const isAbled = Object.values(valid).every((value) => value === true);

  return (
    <div className="reset-pwd card p-6 md:px-10 py-12">
      <div className="h-[72px]">
        <h3 className="text-center">{t("ttl_md_pss_mpg")}</h3>
        <h6 className="text-center text-gray-500">{t("ttl_dscrp_md_mpg")}</h6>
      </div>
      <form className="pwd-rst-form">
        <input
          type="text"
          name="emlId"
          className="mb-2"
          onBlur={(e) => {
            const value = e.currentTarget.value;
            const nextEl = e.currentTarget
              .nextElementSibling as HTMLLabelElement;
            if (!emailRegex.test(value)) {
              nextEl.innerText = t("alr_reg_mail");
              nextEl.style.color = "red";
            }
            if (emailRegex.test(value)) {
              setemlId(value);
              nextEl.innerText = "";
            }
          }}
        />
        <input
          type="password"
          name="lgnPwd"
          className="mt-1 md:mt-[1.5rem]"
          onChange={(e) => {
            const value = e.currentTarget.value;
            setValid({
              ...valid,
              isEnCharValid: englishRegex.test(value) ? true : false,
              isNumCharValid: numberRegex.test(value) ? true : false,
              isSpecialCharValid: specialCharRegex.test(value) ? true : false,
              isRangeCharValid:
                value.length >= 8 && value.length <= 20 ? true : false,
            });

            setLgnPwd(e.currentTarget.value);
          }}
        />
        <label
          htmlFor="lgnPwd"
          onClick={(e) => {
            const prev = e.currentTarget.previousSibling as HTMLInputElement;

            prev.type === "text"
              ? (prev.type = "password")
              : (prev.type = "text");

            prev.type === "text"
              ? (e.currentTarget.className = "on")
              : (e.currentTarget.className = "");
          }}
        />
        <div className="flex gap-3 mt-2 md:mb-[1.5rem] ">
          <h6 className={valid.isEnCharValid ? "on" : ""}>{t("txt_en_cmm")}</h6>
          <h6 className={valid.isNumCharValid ? "on" : ""}>
            {t("txt_num_cmm")}
          </h6>
          <h6 className={valid.isSpecialCharValid ? "on" : ""}>
            {t("txt_spc_cmm")}
          </h6>
          <h6 className={valid.isRangeCharValid ? "on" : ""}>
            8 ~ 20 {t("txt_lss_cmm")}
          </h6>
        </div>
        <input
          type="password"
          name="lgnPwdcheck"
          onChange={(e) => {
            const value = e.currentTarget.value;

            setValid({
              ...valid,
              isEquali: value === lgnPwd,
            });
          }}
        />
        <label
          htmlFor="lgnPwdcheck"
          onClick={(e) => {
            const prev = e.currentTarget.previousSibling as HTMLInputElement;

            prev.type === "text"
              ? (prev.type = "password")
              : (prev.type = "text");

            prev.type === "text"
              ? (e.currentTarget.className = "on")
              : (e.currentTarget.className = "");
          }}
        />
        <h6 className={"mt-[10px]" + " " + (valid.isEquali ? "on" : "")}>
          {t("txt_pss_mtch_cmm")}
        </h6>
      </form>
      <div className="center">
        <button
          className="btn px-8 mt-20"
          disabled={!isAbled}
          onClick={handleResetPwd}
        >
          {t("ttl_md_pss_mpg")}
        </button>
      </div>
    </div>
  );
}
